import React from 'react';

const ArrowCar = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 20" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path
        id="arrowCar_a"
        d="M755.42 2057.06l-.29-1.75a6.14 6.14 0 0 0-5.11-5.18l-2.41-.52a6.37 6.37 0 0 1-2.27-.98l-4.08-2.84a9.81 9.81 0 0 0-5.65-1.79H732v1.82h3.61a8.2 8.2 0 0 1 4.7 1.48l4.1 2.84c.85.6 1.83 1.03 2.85 1.25l2.49.54a4.4 4.4 0 0 1 3.7 3.7l.28 1.74c.04.29-.03.57-.22.8a.94.94 0 0 1-.77.37h-2.51a4.37 4.37 0 0 0-4.2-3.63 4.36 4.36 0 0 0-4.2 3.63H732v1.82h9.82a4.36 4.36 0 0 0 4.2 3.64c2.08 0 3.81-1.57 4.2-3.64h2.53c.81 0 1.58-.38 2.08-1.01.5-.64.71-1.47.59-2.29m-9.39 5.13c-1.42 0-2.58-1.23-2.58-2.73s1.16-2.73 2.58-2.73c1.42 0 2.58 1.22 2.58 2.73 0 1.5-1.16 2.73-2.58 2.73"
      />
    </defs>
    <use fill="#fff" xlinkHref="#arrowCar_a" transform="translate(-732 -2044)" />
  </svg>
);

export default ArrowCar;



// WEBPACK FOOTER //
// ./src/common/icons/ArrowCar.js